import Homework from "@/models/Homework";
export default class AssignedHomework extends Homework {
    resource() {
        return "assigned/homework";
    }
}
